export const HISTORY_REQUESTER = {
    Candidate: 'Candidato',
    Assistant: 'Assistente',
    System: 'Cadastraqui',
} 